import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Draggable } from 'react-beautiful-dnd';
import sha256 from 'crypto-js/sha256';
import { Document, Page } from 'react-pdf';




function CvEdit({ dragHandleProps }) {

  const { t } = useTranslation();

  const apiUrl = process.env.REACT_APP_BACKEND_URL
  const ImageUrl = process.env.REACT_APP_IMAGES_URL


  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  let LanguageSelected = Cookies.get('LanguageSelected');

  const hashedUserId = sha256((String(userId)));


  const [CvModal, setCvModal] = useState(false)
  const [EditCvModal, setEditCvModal] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])
  const [CvInfo, setCvInfo] = useState('')
  const [Done, setDone] = useState(false)
  const [CvId, setCvId] = useState()
  const [isFetching, setIsFetching] = useState(false);
  const [CvContent, setCvContent] = useState(null)

  const AddingCvContent = (e) => {
    const Cv = e.target.files[0]
    setCvInfo(Cv)
  }



  useEffect(() => {
    if (CvModal || EditCvModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [CvModal, EditCvModal]);


  useEffect(() => {
    fetch(`${apiUrl}/GetCvInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setCvContent(result.data)

        }
      })
  }, [Done])


  const StoreCvInfo = async (e) => {
    setIsFetching(true);

    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('Cv', CvInfo);
      formData.append('user_id', userId);

      const response = await axios.post(`${apiUrl}/StoreCvInfo`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${UserToken}`
        },
      });

      if (response.data.success) {
        setCvInfo('');
        setDone(!Done);
        setInputsErrors([]);
        setCvModal(false);
        toast.success(response.data.message, {
          position: toast.POSITION.CENTER
        });
      } else {
        setInputsErrors(response.data.errors);
      }
    } catch (error) {
      // Handle error
      console.error('Error:', error);
    } finally {
      setIsFetching(false);
    }
  };



  const DeleteCvInfo = (e, id) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeleteCvInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ CvId: id })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)

        }
      })
  }


  const openPDFInNewWindow = () => {
    const pdfUrl = `${ImageUrl}/${hashedUserId}/${CvContent?.FilePath}`;

    window.open(pdfUrl, '_blank');
  };


  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>

      <section
        className="Cv sections rounded-xl pt-3 pb-3 pl-3 m-3"
      >
        <div className='flex justify-between'>
          <div>
            <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-4' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t('Cv')}</h1>
          </div>


          {CvContent != null &&
            <div className={`flex justify-center items-center gap-2 ${LanguageSelected == 'ar' ? 'mr-0.5' : 'mr-5'}`}>

              <div className="flex items-center justify-center -mt-5">

                <svg onClick={(e) => { DeleteCvInfo(e, CvContent.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className='w-6'>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                </svg>
              </div>

              <div className="flex items-center justify-center -mt-5">



              </div>
            </div>

          }


        </div>

        {CvContent != null &&
          <div className="text flex items-center h-fit m-2 p-1">
            <a onClick={(e) => { openPDFInNewWindow() }} className='flex h-20 justify-center items-center div-sections w-full  rounded-md px-10'>
              <div className='w-5/6 gap-4 h-full flex justify-start items-center'>
                <img src='https://png.pngtree.com/png-clipart/20220612/original/pngtree-pdf-file-icon-png-png-image_7965915.png' className='w-12 h-12' alt='pdf image' />

                <p className='font-[700] text-lg text-theme'>{t('Download my CV')}</p>

              </div>
              <div className='w-1/6 h-full  flex justify-end items-center'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>


              </div>

            </a>
          </div>

        }

        {CvContent == null &&
          <a onClick={() => { setCvModal(true) }}>
            <main className="flex p-5  items-center justify-center  ">
              <label htmlFor="dropzone-file-Cv" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded-xl border-2 border-dashed border-gold div-sections p-6 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 ">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="mt-2 text-about tracking-wide">{t("Entrez votre Cv.")}</p>
              </label>
            </main>
          </a>
        }


        <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
          </svg>

        </div>

      </section>

      {CvModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setCvModal(false); setInputsErrors([]); setCvInfo('') }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl mb-2 text-theme ">{t('Cv')}</h2>
              <form className="space-y-6 text-Cv">
                <div>
                  <label htmlFor="phoneNumber" className="textModal  ">{t("Présentez-vous, Entrez votre Cv.!")}</label>
                  <div className="mt-5">

                    <label htmlFor="dropzone-file-portfolio" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections">
                      <div className="relative flex flex-col items-center justify-center pt-5 pb-6">
                        <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                          </path>
                        </svg>
                        <center>
                          <p className="mb-2 text-sm text-gray-300">
                            <span className="font-semibold">{t("Cliquez pour télécharger")}</span>
                          </p>
                        </center>
                        <p className="text-xs text-gray-400">PDF (MAX. 10MG)</p>
                        <p className="text-sm text-theme mt-4 font-semibold">{CvInfo?.name}</p>

                        <p className="mt-2 text-center text-red-600"><span className="font-xsmall">{InputsErrors.hasOwnProperty('FilePath') && InputsErrors.FilePath}</span></p>

                      </div>
                      <input onChange={(e) => { AddingCvContent(e); }} id="dropzone-file-portfolio" type="file" name='FilePath' className="hidden" />
                    </label>

                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Cv') && InputsErrors.Cv}</span></p>

                  </div>
                </div>
                <button onClick={(e) => StoreCvInfo(e)} disabled={isFetching} type="submit" className={`w-full  btn-edit`}>
                  {t('enregistrer')}
                </button>
              </form></div>
          </div>
        </div>


      }


    </div>
  )
}

export default CvEdit